module.exports = __webpack_public_path__ + "static/media/gq.d392d4aa.svg";